const isArray = (value) => Array.isArray(value);
export { isArray };
